export default __webpack_public_path__ + "static/media/Kuruah-side-logo.18d812bf.svg";